export default "__VITE_ASSET__Bq4LbZhI__"